import * as angular from 'angular';
import upp from 'app/app.module';
import * as i18nCountries from 'i18n-iso-countries';

SelectCountryComponent.$inject = [ '$scope', '$attrs', 'countryApiService', 'translator'];
function SelectCountryComponent($scope, $attrs, countryApiService,translator) {
    /**
     * @type {Rx.Observable<Country[]>}
     */
    var countries$ = Rx.Observable.fromPromise(countryApiService.getCountries().then(function(result) {
        return translateCountires(result);
    }));

    /**
     * Observable that emits every time the value passed via directive
     * attribute value changes.
     * @type {Rx.Observable<string>}
     */
    var value$ = new Rx.Observable(function(subscription) {
        var next = function(val) { subscription.next(angular.copy(val)) };
        if ($scope['value'])
            next($scope['value'])
        return $scope.$watch('value', next);
    });
    /**
     * Local value emitter of the selected country.
     * @type {Rx.BehaviorSubject<string>}
     */
    var localValue$ = new Rx.BehaviorSubject();
    Object.defineProperties(this, {
        countries$: { value: countries$ },
        countryCode: {
            get: function() { return localValue$.getValue() },
            set: function(val) { localValue$.next(val) },
        },
        onChange: { get: function() { return $scope['onChange'] || angular.noop } },
        // Input component attributes
        required: { get: function() { return !!$attrs['required'] } },
        readonly: { get: function() { return !!$attrs['readonly'] } },
        disabled: { get: function() { return !!$attrs['disabled'] } },
    });

    // Wire emisions and events
    // > Emit any value$ coming from the input attribute as a local value
    var subValues = value$.subscribe(function(val) { localValue$.next(val) });
    // > Notify any localValue$ via callback
    var subNotifyChanges = localValue$
        .filter(function(val) { return !!val })
        .subscribe(function(val) { this.onChange({ $event: val }) }.bind(this));
    // Unregister on destroy
    $scope.$on('$destroy', function() {
        subValues.unsubscribe();
        subNotifyChanges.unsubscribe();
    })

    function translateCountires(countries){
        var lang = translator.getLang();
        i18nCountries.registerLocale(require("i18n-iso-countries/langs/" + lang + ".json"));
        countries.forEach(function (elem, i) {
            elem.name=i18nCountries.getName(elem.iso3, lang);
        });
        return countries;
    }

}


upp.directive('selectCountry', function () {
    return {
        restrict: 'E',
        scope: {
            value: '=',
            onChange: '&?',
        },
        templateUrl: require('./select-country.component.html'),
        styles: require('./select-country.component.less'),
        controllerAs: '$ctrl',
        controller: SelectCountryComponent,
    };
});




// WEBPACK FOOTER //
// ./src/app/common/components/select-country/select-country.component.js